/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {ModelState}
 */
export const componentState = {
    categories: [],
    byCategory: [],
    components: [],
    all: [],
    loading: false,
};


/**
 * @typedef {object} Category
 * @property {string} guid
 * @property {string} name
 * @property {string} category
 */

/**
 * @typedef {object} ComponentConfig
 * @property {string} guid
 * @property {string} type
 * @property {string} label
 * @property {string} icon
 * @property {boolean} hide_label
 * @property {boolean} disabled
 * @property {string} created_at
 * @property {string} updated_at
 */

